import * as React from "react";
import { UitkFigure, UitkImage } from "uitk-react-images";

import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { cropResizeSrc } from "src/components/shared/BlossomImage/BlossomImage";

export interface HeroImageProps {
  src: string;
  alt: string;
  className?: string;
  context: ExtendedContextStore;
}

export const HeroImage: React.FC<HeroImageProps> = ({ context, src, alt, children, className = "" }) => {
  const optimizeImg = cropResizeSrc(src, { width: 1680, height: 485 }, "medium");

  return (
    <UitkFigure className={className}>
      <UitkImage alt={alt} src={optimizeImg} className="bexHeroImageBackground" />
      {children}
    </UitkFigure>
  );
};
